import { useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';

export function useCondensedInfiniteScroll(): boolean {
  const { payloadToSSR } = useContext(AppDataContext);
  const { experiments } = payloadToSSR;

  if (!experiments) return false;

  return experiments.some((experiment) => experiment.includes('go-deeper|v1'));
}
